import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import fallbackImage from "../../shared/icons/fallback-image.png";
import styles from "./styles.m.css";

const EvolokRecommendationUnit = ({
  recommendation,
  className = "sidebar",
  count = 5,
  title = "Evolok",
  pfrom = "ev-recommendation"
}) => {
  const articleItems =
    recommendation.length > 0 &&
    recommendation.slice(0, count).map((item, i) => {
      return (
        <article key={i} className={styles["ev-content-item"]}>
          <div className={styles["ev-content-item-thumbnail"]}>
            <img
              src={`${get(item, ["thumbnailUrl"], fallbackImage)}?format=webp&w=120&dpr=1.0`}
              width="120"
              height="67"
              className="gm-added gm-loaded gm-observing gm-observing-cb"
              loading="lazy"
            />
          </div>
          <div className={styles["ev-content-item-title"]}>
            <a href={`${get(item, ["contentUrl"], "")}?pfrom=${pfrom}`}>
              {get(item, ["title"], "").replace(/&quot;/g, '"')}
            </a>
          </div>
        </article>
      );
    });

  return (
    <React.Fragment>
      {recommendation.length > 0 ? (
        <div className={`${styles["ev-recommendation-base"]} ${styles[className]}`}>
          <h4 className={styles["headline"]}>
            <span>{title}</span>
          </h4>
          <div className={`${styles["ev-content-recommendations"]}`}>{articleItems}</div>
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

EvolokRecommendationUnit.propTypes = {
  className: PropTypes.string,
  recommendation: PropTypes.shape(),
  count: PropTypes.number,
  title: PropTypes.string,
  pfrom: PropTypes.string
};

export default EvolokRecommendationUnit;
